import { action, orchestrator } from 'satcheljs';
import { selectCategory as selectCategoryOrchestrator } from 'owa-options-store';
import confirmDirtyOptionsAndPerformAction from './confirmDirtyOptionsAndPerformAction';
import { OptionCategory } from 'owa-options-core';

const selectCategory = action('selectCategory', (category: OptionCategory) => ({ category }));
export default selectCategory;

orchestrator(selectCategory, actionMessage => {
    const continueAfterConfirmCallback = () => {
        selectCategoryOrchestrator(actionMessage.category);
    };

    confirmDirtyOptionsAndPerformAction(continueAfterConfirmCallback);
});
